import { Flex, Text } from '@chakra-ui/react';
import {
  JobEntity as JobEntityData,
  JobEntityType,
} from '@texas/api/endpoints/jobRecordsApi';
import { useTranslation } from 'react-i18next';
import { AngularNavLink } from '../shared/AngularNavLink';
import { Icons } from '../shared/Icons';
import { getEntityInitials, getEntityTypeLabel } from './jobPresentation';

export function JobEntity({ entity }: { entity: JobEntityData }) {
  const { t } = useTranslation();
  const navigation = getEntityNavigation(entity);
  const content = (
    <Flex align="center" gap={2.5} minW={0} role="group">
      <Flex
        w="32px"
        h="32px"
        flexShrink={0}
        align="center"
        justify="center"
        bg="entityDirectory.badgeBackground"
        border="1px solid"
        borderColor="entityDirectory.border"
        fontFamily="barlow"
        fontSize="10px"
        fontWeight="bold"
      >
        {getEntityInitials(entity.type)}
      </Flex>
      <Flex direction="column" minW={0}>
        <Flex align="center" gap={1}>
          <Text noOfLines={1} fontSize="12px" fontWeight="semibold">
            {entity.label}
          </Text>
          {navigation && (
            <Icons.OpenInNew
              boxSize={3}
              color="entityDirectory.mutedText"
              flexShrink={0}
              opacity={0}
              _groupHover={{ opacity: 1 }}
            />
          )}
        </Flex>
        <Text noOfLines={1} color="entityDirectory.mutedText" fontSize="10px">
          {getEntityTypeLabel(entity.type, t)}
          {entity.context ? ` · ${entity.context}` : ''}
        </Text>
      </Flex>
    </Flex>
  );

  if (!navigation) return content;

  return (
    <AngularNavLink
      navobj={navigation.navobj}
      textDecoration="none"
      to={navigation.route}
      variant="unstyled"
      w="full"
      _hover={{ textDecoration: 'none' }}
    >
      {content}
    </AngularNavLink>
  );
}

function getEntityNavigation(entity: JobEntityData) {
  switch (entity.type) {
    case JobEntityType.Article:
      return { route: 'article', navobj: { articleId: entity.id } };
    case JobEntityType.Customer:
      return { route: 'customer', navobj: { customerId: entity.id } };
    case JobEntityType.Concept:
      return { route: 'concept', navobj: { conceptId: entity.id } };
    case JobEntityType.Supplier:
      return { route: 'supplier', navobj: { supplierId: entity.id } };
    default:
      return null;
  }
}
